<template>
    <div component="Icon" template="horizontal---">
        <div icon="voice" v-if="code == 'voice'">
            <div class="label">VOICE <i>&</i> FACE <span>DATABASE</span></div>
            <div class="icon">mic_none</div>
        </div>

        <div icon="music" v-if="code == 'music'">
            <div class="label">MUSIC ZONE</div>
            <div class="icon">queue_music</div>
        </div>

        <div icon="about" v-if="code == 'about'">
            <div class="icon">portrait</div>
            <div class="label">ABOUT</div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Icon',

    props: {
        code: {
            type: String,
            required: true,
        },
    },

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='Icon'] {
    // FLEX RESET
    display: block !important;
    position: relative !important;
    // neprekonávať !!! componenta má vlastný flex je potrebné ho resetovať
    // Rovnako je vhodne resetovať position.

    transition: 0.5s;
}

[component='Icon'][template='horizontal'] {
    [icon] {
        display: flex;
        align-items: center;
        width: auto;

        .label {
            position: relative;
            transform: none;
            top: auto;
            left: auto;
            bottom: auto;
            font-size: 80px;
            padding-left: 20px;
            color: white;

            i {
                font-weight: normal;
                font-style: normal;
            }
        }

        .icon {
            top: auto;
            left: auto;
            position: relative;
        }
    }

    [icon='voice'],
    [icon='music'] {
        flex-direction: row-reverse;
    }
}

// CONTAINERS

[component='Icon'] {
    [icon] {
        position: relative;
        width: 150px;
        height: 150px;
        margin-left: 0px;
        // background-color: rgba(0,0,0,0.2);

        .label {
            position: absolute;
            font-size: 17px;
            font-weight: 900;
            white-space: nowrap;
            color: @black;
            transition: 0.5s;

            i {
                font-weight: normal;
                font-style: normal;
            }
        }

        .icon {
            position: absolute;
            left: 0;
            top: 0;
            font-size: 150px;
            color: fade(@black, 30%);
        }
    }

    [icon='voice'] {
        .label {
            left: 90px;
            top: 20px;
            line-height: 1.2;
            text-align: left;

            span {
                display: block;
            }
        }

        .icon {
            left: -20px;
            top: 0px;
        }
    }
    [icon='music'] {
        .label {
            left: 20px;
            top: 5px;
        }

        .icon {
            // left: 0px;
            // top: 0px;
        }
    }
    [icon='about'] {
        .label {
            left: 50%;
            transform: translateX(-50%);
            bottom: -10px;
        }

        .icon {
            // left: 0px;
            // top: -15px;
        }
    }

    @media (max-height: 420px) {
        [icon] {
            display: flex;
            align-items: center;
            width: auto;

            .label {
                position: relative;
                transform: none;
                top: auto;
                left: auto;
                bottom: auto;
                font-size: 80px;
                padding-left: 20px;
            }

            .icon {
                top: auto;
                left: auto;
                position: relative;
            }
        }

        [icon='voice'],
        [icon='music'] {
            flex-direction: row-reverse;
        }
    }
}

// BLOCKS

[component='Icon'] [block=''] {
}

// STAV

[component='Icon'][state=''] {
}

// TAG

[component='Icon'][tag=''] {
}
</style>
